"use client";

import { useEffect, useState } from "react";
import type z from "zod";

export function useLocalStorage<T>(
  name: string,
  schema: z.ZodSchema<T>,
  defaultValue: T,
) {
  const [value, setValue] = useState<T>(() => {
    if (typeof window !== "undefined") {
      try {
        const value = localStorage.getItem(name);

        if (value) {
          return schema.parse(JSON.parse(value));
        }
      } catch {}
    }

    return defaultValue;
  });

  useEffect(() => {
    if (value === undefined) {
      localStorage.removeItem(name);
    } else {
      localStorage.setItem(name, JSON.stringify(value));
    }
  }, [value, name]);

  return [value, setValue] as const;
}
